import { useLanguage } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y border-white/10 bg-[#0B0B0E] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 shrink-0">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 shrink-0">
                <span className={`f-display text-2xl md:text-3xl font-extrabold tracking-tight whitespace-nowrap ${i % 2 === 0 ? "text-slate-50" : "text-outline"}`}>
                  {item}
                </span>
                <span className="w-2 h-2 rounded-full bg-red-600 shrink-0" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
